var render = function render(){var _vm=this,_c=_vm._self._c;return _c('BaseContentWrapper',{staticClass:"base-list-item"},[_c('div',{staticClass:"base-list-item__title"},[_vm._t("title")],2),_c('div',[_vm._t("actions")],2),(_vm.$scopedSlots.badges)?_c('div',{staticClass:"base-list-item__badges"},[_vm._t("badges")],2):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }